var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileProtected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 32.4243,
    height: 32.4243,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2119 28.3705H6.07925V4.05226H14.1853V10.1318C14.1869 10.6688 14.4009 11.1834 14.7806 11.5631C15.1603 11.9428 15.6749 12.1568 16.2119 12.1583H22.2914V15.1981H24.3179V10.1318C24.3216 9.99864 24.2963 9.86627 24.2438 9.74382C24.1913 9.62136 24.1129 9.51175 24.014 9.42254L16.9211 2.32972C16.8319 2.23075 16.7223 2.15232 16.5999 2.09984C16.4774 2.04736 16.345 2.02207 16.2119 2.02574H6.07925C5.54226 2.02729 5.02771 2.2413 4.648 2.62101C4.26829 3.00072 4.05428 3.51527 4.05273 4.05226V28.3705C4.05428 28.9075 4.26829 29.422 4.648 29.8018C5.02771 30.1815 5.54226 30.3955 6.07925 30.397H16.2119V28.3705ZM16.2119 4.45756L21.8861 10.1318H16.2119V4.45756Z",
    fill: "#1956A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6498 31.7453L21.0527 30.5155C20.0152 30.0211 19.1386 29.2436 18.5238 28.2726C17.9091 27.3016 17.5813 26.1766 17.5781 25.0274V17.1733H29.7214V25.0274C29.7184 26.1767 29.3906 27.3018 28.7759 28.2729C28.1611 29.2441 27.2844 30.0217 26.2469 30.5161L23.6498 31.7453ZM20.0068 19.602V25.0274C20.0087 25.7168 20.2054 26.3916 20.5743 26.9741C20.9432 27.5565 21.4691 28.0228 22.0915 28.3193L23.6498 29.0569L25.208 28.3193C25.8304 28.0228 26.3564 27.5565 26.7252 26.9741C27.0941 26.3916 27.2908 25.7168 27.2928 25.0274V19.602H20.0068Z",
    fill: "#1956A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileProtected);
export default __webpack_public_path__ + "static/media/icon_FileProtected.ac8b98dfdff74d6fd77e907c112285be.svg";
export { ForwardRef as ReactComponent };